import React, { SVGProps } from 'react';

function InactiveFollowUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3.5" y="3.5" width="18" height="18" rx="9" fill="#FEFEFE" />
      <rect x="3.5" y="3.5" width="18" height="18" rx="9" stroke="#BABBC0" strokeWidth="2" />
      <mask id="mask0_6404_4655" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="5" width="15" height="15">
        <rect x="5.5" y="5.5" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6404_4655)">
        <path d="M11.0708 14.3375L16.0145 9.39375C16.1312 9.27708 16.2673 9.21875 16.4228 9.21875C16.5784 9.21875 16.7145 9.27708 16.8312 9.39375C16.9478 9.51042 17.0062 9.64896 17.0062 9.80937C17.0062 9.96979 16.9478 10.1083 16.8312 10.225L11.4791 15.5917C11.3624 15.7083 11.2263 15.7667 11.0708 15.7667C10.9152 15.7667 10.7791 15.7083 10.6624 15.5917L8.15408 13.0833C8.03742 12.9667 7.98151 12.8281 7.98638 12.6677C7.99124 12.5073 8.052 12.3688 8.16867 12.2521C8.28533 12.1354 8.42388 12.0771 8.58429 12.0771C8.74471 12.0771 8.88325 12.1354 8.99992 12.2521L11.0708 14.3375Z" fill="#BABBC0" stroke="#BABBC0" />
      </g>
    </svg>
  );
}

export default InactiveFollowUpIcon;
